import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Static crawler JSON-LD (scripts/vite-plugin-seo-static.mjs) is for no-JS fetchers only.
// Once JS runs, each page emits its own schema — drop the static copy to avoid duplicates.
document.querySelectorAll('script[data-seo-static]').forEach((n) => n.remove())

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)